/**
 *
 * @param {number} expiryDate
 * @returns {number} return number of days left
 */

export const calculateRemainingDays = (expiryDate) => {
  const expiryTimestamp =
    typeof expiryDate !== Number ? Number(expiryDate) : expiryDate;
  const currentTimestamp = Date.now();
  const diffMilliseconds = expiryTimestamp - currentTimestamp;
  const millisecondsInOneDay = 86400000;
  const diffDays = Math.ceil(diffMilliseconds / millisecondsInOneDay);
  return diffDays;
};
